module.exports = __webpack_public_path__ + "ddb07e5a88485909edb1c19442ebf722.jpg";